import { createAction, props } from '@ngrx/store';
import { AmazonFulfilmentCenter } from '../../features/amazon-fulfilment-centers/services/amazon-fulfilment-centers.service';

// Load Centers
export const loadCenters = createAction('[Amazon Fulfilment Center] Load Centers');
export const loadCentersSuccess = createAction(
  '[Amazon Fulfilment Center] Load Centers Success',
  props<{ centers: AmazonFulfilmentCenter[] }>()
);
export const loadCentersFailure = createAction(
  '[Amazon Fulfilment Center] Load Centers Failure',
  props<{ error: string }>()
);

// Create Center
export const createCenter = createAction(
  '[Amazon Fulfilment Center] Create Center',
  props<{ center: Partial<AmazonFulfilmentCenter> }>()
);
export const createCenterSuccess = createAction(
  '[Amazon Fulfilment Center] Create Center Success',
  props<{ center: AmazonFulfilmentCenter }>()
);
export const createCenterFailure = createAction(
  '[Amazon Fulfilment Center] Create Center Failure',
  props<{ error: string }>()
);

// Update Center
export const updateCenter = createAction(
  '[Amazon Fulfilment Center] Update Center',
  props<{ id: string, center: Partial<AmazonFulfilmentCenter> }>()
);
export const updateCenterSuccess = createAction(
  '[Amazon Fulfilment Center] Update Center Success',
  props<{ center: AmazonFulfilmentCenter }>()
);
export const updateCenterFailure = createAction(
  '[Amazon Fulfilment Center] Update Center Failure',
  props<{ error: string }>()
);

// Delete Center
export const deleteCenter = createAction(
  '[Amazon Fulfilment Center] Delete Center',
  props<{ id: string }>()
);
export const deleteCenterSuccess = createAction(
  '[Amazon Fulfilment Center] Delete Center Success',
  props<{ id: string }>()
);
export const deleteCenterFailure = createAction(
  '[Amazon Fulfilment Center] Delete Center Failure',
  props<{ error: string }>()
); 